import React from 'react';
import { arrayOf, func, shape, string } from 'prop-types';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { styled } from '@mui/material/styles';

const RadioButton = styled(Box)(({ theme }) => ({
  '& .MuiFormControlLabel-label': {
    display: 'flex',
    justifyContent: 'space-between',
  },
  '& label': {
    width: '100%',
  },
  '&:last-child': {
    marginBottom: theme.spacing(3),
  },
  borderRadius: 24,
  marginTop: theme.spacing(2),
  paddingLeft: theme.spacing(2),
}));

const MRadioGroup = ({ selection, onChange, name, options }) => {
  return (
    <RadioGroup onChange={onChange} value={selection}>
      {options.map(({ value, label }) => (
        <RadioButton
          bgcolor={selection === value ? 'secondary.light' : 'surface.white'}
          border={selection === value ? 0 : 1}
          borderColor={selection === value ? 'none' : 'graphic.main'}
          key={value}
          width="100%"
        >
          <FormControlLabel control={<Radio />} label={label} name={name} value={value} />
        </RadioButton>
      ))}
    </RadioGroup>
  );
};

MRadioGroup.propTypes = {
  name: string.isRequired,
  onChange: func.isRequired,
  options: arrayOf(shape({ label: string.isRequired, value: string.isRequired })).isRequired,
  selection: string,
};
MRadioGroup.defaultProps = {
  selection: undefined,
};

export default MRadioGroup;
